import { LocalStorageService } from "utils/localStorage";

const activeScenarioStorageKey = (projectId: string) => `technicalDataActiveScenario:${projectId}`;

export const loadActiveScenarioId = (projectId?: string): null | number => {
  if (!projectId) return null;
  const stored = LocalStorageService.getItem<unknown>(activeScenarioStorageKey(projectId));
  return typeof stored === "number" && Number.isFinite(stored) ? stored : null;
};

export const saveActiveScenarioId = (projectId: string | undefined, scenarioId: null | number) => {
  if (!projectId || scenarioId == null) return;
  LocalStorageService.setItem(activeScenarioStorageKey(projectId), scenarioId);
};
